export const handleExternalLink = (link) =>{
    window.open(link, "_blank");
}